import { render, staticRenderFns } from "./loginContent.vue?vue&type=template&id=57a96f56&scoped=true&"
import script from "./loginContent.vue?vue&type=script&lang=js&"
export * from "./loginContent.vue?vue&type=script&lang=js&"
import style0 from "./loginContent.vue?vue&type=style&index=0&id=57a96f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a96f56",
  null
  
)

export default component.exports